import {FAILURE, PENDING, SUCCESS} from '../../constants'
import {deleteShareableCalendarView as deleteShareableCalendarViewAPI} from '../../../services/shareableCalendarViews/shareableViews'

export async function deleteShareableCalendarView(dispatch, data) {
  try {
    dispatch({type: PENDING})
    let response = await deleteShareableCalendarViewAPI(data)
    dispatch({type: SUCCESS, payload: response})
    return response
  } catch (e) {
    console.log(`Delete Calendar View Failed: ${data}`)
    dispatch({type: FAILURE, payload: e})
    return Promise.reject(e)
  }
}
